// extracted by mini-css-extract-plugin
export default {"primaryColor":"#1890ff","backColor":"#f0f2f5","buttonSpacing":"8px","textButtonSpacing":"4px","crossMark":"crossMark_crossMark__Lk0RV","leftPart":"crossMark_leftPart__Yzd3z","buttonBox":"crossMark_buttonBox__RK6-R","roadBox":"crossMark_roadBox__l8tOZ","roadItem":"crossMark_roadItem__0PcCk","rightPart":"crossMark_rightPart__jC-86","title":"crossMark_title__CtsRA","mapBox":"crossMark_mapBox__zRS7s"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"primaryColor\":\"#1890ff\",\"backColor\":\"#f0f2f5\",\"buttonSpacing\":\"8px\",\"textButtonSpacing\":\"4px\",\"crossMark\":\"crossMark_crossMark__Lk0RV\",\"leftPart\":\"crossMark_leftPart__Yzd3z\",\"buttonBox\":\"crossMark_buttonBox__RK6-R\",\"roadBox\":\"crossMark_roadBox__l8tOZ\",\"roadItem\":\"crossMark_roadItem__0PcCk\",\"rightPart\":\"crossMark_rightPart__jC-86\",\"title\":\"crossMark_title__CtsRA\",\"mapBox\":\"crossMark_mapBox__zRS7s\"}";
        // 1793842502697
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  